define([
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/util"
], function(Action,ActionFactory,util) {

	return ActionFactory.declare("Switchboard", Action, {
		// Boolean: indicates switchboard can select multiple entries and by default all are selected
		//bMultipleAll: false,

		// Boolean: indicates switchboard can select multiple entries and by default none are selected
		//bMultipleNone: false,

		/** @property {boolean} bSecondaryToolbar - makes the switchboard to appear on the secondary toolbar below the main toolbar*/
		// bSecondaryToolbar: false,

		// String: default tag for action
		m_tag: "Switchboard",

		constructor: function(obj) {
			var	multiple = util.getProperty(obj, "Multiple");
			if (multiple == "All") {
				this.bMultipleAll = true;
			} else if (multiple == "None") {
				this.bMultipleNone = true;
			}

			this.bSecondaryToolbar = util.getBooleanProperty(obj, "SecondaryToolbar");

			if (!this.classToolbarPlugin) {
				this.classToolbarPlugin = multiple ? "csi/toolbar/MultiSelectSwitchboard" : "csi/view/ToolbarPluginSwitchboard";
			}
		},

		_getNameParams: function(/*LocaleResolver*/lr) {
			// summary: return array of parameters used to help name action
			if (this.m_viewRef) {
				var	rc = this.m_viewRef.getReferencedClass(this.m_rcTarget);
				if (rc) {
					return [lr.getTypeView(rc.getType(), this.m_viewRef.m_id)];
				}
			}

			return null;
		}
	});
});